<span
  data-cy="input-location"
  tooltipPosition="top"
  tooltipZIndex="2100"
  [attr.data-cy-columnName]="data ? data.columnName : columnName"
  [escape]="false"
  [hideDelay]="250"
  [life]="3000"
  pTooltip="{{ tooltip }}"
  [showDelay]="500"
  [style.display]="displayCss"
  (contextmenu)="onContextMenu($event)">
  @if (this.isLabelDisplay && label) {
    <label
      iu-apiz-label
      [fontSize]="overridedCSS?.labelFontSize"
      [for]="uuid"
      [isFieldOnly]="data?.isFieldOnly"
      [label]="label">
      <span class="adressLabelZoom" (click)="zoomAcross()">
        {{ label }}
      </span>
    </label>
  }
  <input
    #input
    autocomplete="off"
    type="text"
    [attr.value]="fieldValue ? fieldValue.displayValue : ''"
    [ngClass]="[
      'input-field p-inputtext',
      hasConflict ? 'iu-input-text-conflict' : '',
      mandatoryCss || '',
      'ui-corner-all',
    ]"
    [ngModel]="fieldValue ? fieldValue.displayValue : ''"
    [readonly]="isReadOnly ? 'disabled' : null"
    [tabindex]="isReadOnly ? '-1' : null"
    (keydown)="blocInput()"
    (ngModelChange)="fieldValue ? (fieldValue.displayValue = $event.target.value) : ''" />
  <i
    aria-hidden="true"
    class="iconeLocation fa-map-marker"
    data-cy="button-location"
    type="button"
    [attr.readonly]="isReadOnly ? 'disabled' : null"
    (click)="!isReadOnly && toggleOverlay($event)"></i>
  @if (hasConflict && dataStored) {
    <span #spanInput class="p-autocomplete-conflict-star" (mouseenter)="opConflict.show($event)"> /!\ </span>
  }
  @if (showValuePrefPanel) {
    <iu-prime-overlay #opValuePref appendTo="body" [dismissable]="false">
      <iu-value-preference-panel
        [data]="this.data"
        [dataStored]="this.dataStored"
        [fieldValue]="fieldValue"
        [overlayPanel]="opValuePref"
        [sourceComponent]="this"
        (closeEmitter)="toggleValuePreferencePanel($event)" />
    </iu-prime-overlay>
  }
</span>

<iu-prime-overlay #opConflict>
  <a class="data-conflict" (click)="chooseData($event, (dataStored?.data)[data.columnName], true); opConflict.hide()">{{
    (dataStored?.data)[data.columnName]
  }}</a>
  |
  <a class="data-conflict" (click)="chooseData($event, conflictedData, false); opConflict.hide()">{{
    conflictedData
  }}</a>
</iu-prime-overlay>
@if (displayLocationPanel) {
  <iu-modal-ui
    [angularStyle]="{ 'iu-modal': { width: '400px' }, 'iu-modal-body': { padding: 0 } }"
    [appendTo]="'body'"
    [hasCloseBtn]="true"
    [isModalDisplay]="displayLocationPanel"
    (closeModalEmitter)="this.displayLocationPanel = false">
    <div class="locationPanel" data-cy="location-panel" [attr.data-cy-columnName]="data ? data.columnName : columnName">
      <div class="locationPanel-content">
        <ng-template #vcrLocationPanel />
      </div>
    </div>
  </iu-modal-ui>
}
